import {
  RequestAnalyticsIdType,
  RequestAnalyticsAttributes,
} from '@fullstory/proto/fs/services/alexa';

/**
 * getRequestAnalytics is a helper function to create requestAnalytics objects for compute metric payloads
 * @param visualizationType the primary request source id type (funnel, metric, etc)
 * @param named boolean value to represent whether the request source id is named
 * @param id the request source id (funnel id, metric id, etc)
 * @returns a formatted RequestAnalyticsAttributes object, undefined if no id was sent
 */
export const getRequestAnalytics = (
  visualizationType: RequestAnalyticsIdType,
  named: boolean,
  id?: string,
): RequestAnalyticsAttributes | undefined => {
  if (id) {
    return <RequestAnalyticsAttributes>{
      id,
      type: visualizationType,
      ...(typeof named !== 'undefined' && { named }),
    };
  }
  return undefined;
};
